import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import { Grid } from '@mui/material';
import { PageContainer, PaginationComponenets, NewLoading, Icons } from 'components';
import Services from '../services/Services';
import Collapse from '@mui/material/Collapse';
import { useLocation } from 'react-router-dom';
import { createSanitizeHtml } from 'utility';
import { constBreadCrumbsTitle } from 'utility';

import { useStyles } from './Style';
const Faq = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0); // استیت شماره صفحه جاری را ذخیره میکند
  const [totalItems, setTotalItems] = useState(0); // تعداد کل ردیف دیتا رو دارا میباشد
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const itemRef = useRef(null);

  useEffect(() => {
    getFaqs();
  }, []);

  useEffect(() => {
    if (isLoading) return;

    handlePageChange({
      page: currentPage === 0 ? 1 : currentPage,
      pageSize: 5,
      pageNumber: currentPage === 0 ? 0 : currentPage - 1,
      changeData: true,
    });
  }, [currentPage]);

  /**
   * لیست سوالات متدوال را از سرویس دریافت میکند
   */
  const getFaqs = async () => {
    await Services.getFaqs()
      .then((res) => {
        let d = res?.result?.faq;
        for (const item of d) {
          item['isOpen'] = false;
          item.answer = String(item.answer)
            .replace(/class=globalDivClass/g, `class=${classes.globalCustom}`)
            .replace(/class=ulClass/g, `class=${classes.ulClassCustom}`)
            .replace(/class=liClass/g, `class=${classes.liCustom}`)
            .replace(/class=table/g, `class=${classes.tableCustom}`)
            .replace(/class=divImgClass/g, `class=${classes.divImgCustom}`)
            .replace(/class=imgClass/g, `class=${classes.imgCustom}`)
            .replace(/class=trClass/g, `class=${classes.trCustom}`)
            .replace(/class=thClass/g, `class=${classes.thCustom}`)
            .replace(/class=tdContent/g, `class=${classes.tdContentCustom}`)
            .replace(/divClass/g, `${classes.divCustomClass}`);
        }

        setMainData(d);
        setTotalItems(d?.length);

        if (searchParams.get('pathRoute')?.length > 0) {
          const index = res?.result?.faq.findIndex(
            (item) => item.key === searchParams.get('pathRoute'),
          );
          setTimeout(() => {
            let page = Math.ceil((index + 1) / 5);
            setCurrentPage(page);
            setIsLoading(false);
          }, 2000);
        } else {
          setCurrentPage(1);
          setData(d);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  /**
   * تغییر باز یا بسته شدن یک لیست کشویی
   */
  const changeOpen = (index, status, items) => {
    if (items?.length > 0) {
      let copyData = JSON.parse(JSON.stringify(items));
      if (status == true) {
        for (let i = 0; i < copyData.length; i++) {
          const element = copyData[i];
          if (index == i) {
            element.isOpen = true;
          } else {
            element.isOpen = false;
          }
        }
      } else {
        for (const item of copyData) {
          item['isOpen'] = false;
        }
      }
      setData(copyData);
    }
  };

  // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
  const handlePageChange = async (param) => {

    const currentPageItem = param.page === 0 ? 1 : param.page;
    if (param?.changeData) setCurrentPage(currentPageItem);
    else return;

    const start = (currentPageItem - 1) * 5;
    const end = Math.min(currentPageItem * 5, mainData.length);
    const pinchedSlice = mainData.slice(start, end);
    const index = pinchedSlice.findIndex((item) => item.key === searchParams.get('pathRoute'));
    if (index !== -1) {
      const itemElement = itemRef?.current?.children[index];
      setTimeout(() => {
        if (searchParams.get('pathRoute')?.length > 0) {
          changeOpen(index, true, pinchedSlice.slice(0, 5));
        }
        setTimeout(() => {
          if (itemElement) {
            window.scrollTo({
              top: itemElement.offsetTop,
              behavior: 'smooth',
            });
          }
        }, 100);
      }, 200);
    } else {
      setData(pinchedSlice);
    }
  };

  /**
   * به ازای هر منوی کشویی این تابع اجرا میشود و منو و زیر منو را میسازد
   */
  const collpaseItem = (items, index) => {
    return (
      <Grid
        xs={12}
        className={classes.colllapseTop}
        style={{ border: `${!items.isOpen ? '1px solid #f4f4f4' : ''}` }}
        data-item-id={index}
      >
        <Grid
          item
          xs={12}
          style={{ border: `${items.isOpen ? '1px solid #f4f4f4' : ''}` }}
          className={clsx(classes.headItem, items.isOpen ? 'headItemActive' : '')}
          onClick={() => {
            changeOpen(index, !items?.isOpen, data);
          }}
        >
          <span>{items.question} </span>
          {!items?.isOpen ? (

            <span className={classes.iconStyle}
              onClick={() => {
                changeOpen(index, !items?.isOpen, data);
              }}>
              <Icons icon="CaretDown" color="#000" size="18" />
            </span>

          ) : (


            <span className={clsx(classes.iconStyle, classes.iconTop)}

              onClick={() => {
                changeOpen(index, !items?.isOpen, data);
              }}>
              <Icons icon="CaretUp" color="#fff" size="18" />
            </span>
          )}
        </Grid>
        <Grid className={items.isOpen ? classes.collpaseContent : ''}>
          <Collapse style={{ width: '100%' }} in={items.isOpen} timeout="auto" unmountOnExit>
            {items.answer && (
              <Grid className={classes.mr4}>
                <div dangerouslySetInnerHTML={{ __html: createSanitizeHtml(items.answer) }}></div>
              </Grid>
            )}
          </Collapse>
        </Grid>
      </Grid>
    );
  };


  return (
    <PageContainer title="سوالات متداول" breadcrumbs={constBreadCrumbsTitle.TICKET_FAQ} className={classes.contentPage}>
      {
        isLoading ? (
          <div className={classes.blockLoading} >
            <NewLoading />
          </div>
        ) : (
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            item
            className={classes.root}
            ref={itemRef}
          >
            {data &&
              data.map((valueItem, index) => {
                return collpaseItem(valueItem, index, data);
              })}
            <div className={classes.pagination}>
              {!isLoading && (
                // کامپوننت صفحه بندی
                <PaginationComponenets
                  itemsPerPage={5}
                  currentPage={currentPage}
                  pageCount={totalItems}
                  onChange={handlePageChange}
                  removePrePage={true}
                  localCall={true}
                />
              )}
            </div>
          </Grid>
        )

      }
    </PageContainer >
  );
};
export default Faq;
